<!--  -->
<template>
  <div>
    <div
      class="choose_palte"
      style="margin-bottom:10px"
    >
      <div class="chasew">选择平台：</div>
      <div>
        <el-select
          v-model="platformid"
          class="launch"
          filterable
          placeholder="选择平台"
          @change="pirewa"
        >
          <el-option
            v-for="items in platforms"
            :key="items.id"
            :label="items.name"
            :value="items.id"
          />
        </el-select>
      </div>
    </div>
    <el-tabs v-model="activeTopTemp">
      <el-tab-pane
        v-for="item,index in arr"
        :key="index"
        :label="item.text"
        :name="item.indexrw"
      >
        <reading
          v-if="platformid ==2 && item.indexrw == 'first'"
          :platformid="platformid"
          @close="readingclose"
        />
        <readingtwo
          v-if="platformid ==2 && item.indexrw == 'second'"
          :platformid="platformid"
          @close="readingclose"
        />
        <readingthree
          v-if="platformid ==2 && item.indexrw == 'two'"
          :platformid="platformid"
          @close="readingclose"
        />
        <sun
          v-if="platformid == 1 && item.indexrw == 'first'"
          :platformid="platformid"
          @close="readingclose"
        />
        <suntwo
          v-if="platformid == 1 && item.indexrw == 'second'"
          :platformid="platformid"
          @close="readingclose"
        />
        <sunthree
          v-if="platformid == 1 && item.indexrw == 'secondwe'"
          :platformid="platformid"
          @close="readingclose"
        />
        <zsybookactive
          v-if="platformid == 9 && item.indexrw == 'first'"
          :platformid="platformid"
          @close="readingclose"
        />
        <zsybookrecharge
          v-if="platformid == 9 && item.indexrw == 'second'"
          :platformid="platformid"
          @close="readingclose"
        />
        <wdbookactive
          v-if="platformid == 3 && item.indexrw == 'first'"
          :platformid="platformid"
          @close="readingclose"
        />
        <wdbookrecharge
          v-if="platformid == 3 && item.indexrw == 'second'"
          :platformid="platformid"
          @close="readingclose"
        />
        <wandubookactive
          v-if="platformid == 4 && item.indexrw == 'first'"
          :platformid="platformid"
          @close="readingclose"
        />
        <wandubookrecharge
          v-if="platformid == 4 && item.indexrw == 'second'"
          :platformid="platformid"
          @close="readingclose"
        />
        <wandubookvip
          v-if="platformid == 4 && item.indexrw == 'secondwe'"
          :platformid="platformid"
          @close="readingclose"
        />
        <qiyueactive
          v-if="platformid == 6 && item.indexrw == 'first'"
          :platformid="platformid"
          @close="readingclose"
        />
        <qiyueactivetwo
          v-if="platformid == 6 && item.indexrw == 'second'"
          :platformid="platformid"
          @close="readingclose"
        />
        <kswbookactive
          v-if="platformid == 10 && item.indexrw == 'first'"
          :platformid="platformid"
          @close="readingclose"
        />
        <zdbookactive
          v-if="platformid == 11 && item.indexrw == 'first'"
          :platformid="platformid"
          @close="readingclose"
        />
        <zdbookrecharge
          v-if="platformid == 11 && item.indexrw == 'second'"
          :platformid="platformid"
          @close="readingclose"
        />
        <zwbookacive
          v-if="platformid == 12 && item.indexrw == 'first'"
          :platformid="platformid"
          @close="readingclose"
        />
        <zwbookaciveincrease
          v-if="platformid == 12 && item.indexrw == 'second'"
          :platformid="platformid"
          @close="readingclose"
        />
        <zwbookacivevip
          v-if="platformid == 12 && item.indexrw == 'secondwe'"
          :platformid="platformid"
          @close="readingclose"
        />
        <cdactivey
          v-if="platformid == 13 && item.indexrw == 'first'"
          :platformid="platformid"
          @close="readingclose"
        />
        <cdactiveyvip
          v-if="platformid == 13 && item.indexrw == 'second'"
          :platformid="platformid"
          @close="readingclose"
        />
        <cdactiveyzhizeng
          v-if="platformid == 13 && item.indexrw == 'secondwe'"
          :platformid="platformid"
          @close="readingclose"
        />
        <mogu
          v-if="platformid == 31 && item.indexrw == 'first'"
          :platformid="platformid"
          @close="readingclose"
        />
        <yexiangone
          v-if="platformid == 34 && item.indexrw == 'first'"
          :platformid="platformid"
          @close="readingclose"
        />
        <yexiangtwo
          v-if="platformid == 34 && item.indexrw == 'second'"
          :platformid="platformid"
          @close="readingclose"
        />
        <yexiangthree
          v-if="platformid == 34 && item.indexrw == 'secondwe'"
          :platformid="platformid"
          @close="readingclose"
        />
        <duoge
          v-if="platformid == 23 && item.indexrw == 'first'"
          :platformid="platformid"
          @close="readingclose"
        />
        <duogetwo
          v-if="platformid == 23 && item.indexrw == 'second'"
          :platformid="platformid"
          @close="readingclose"
        />
      </el-tab-pane>

    </el-tabs>

  </div>
</template>

<script>
import reading from './reading.vue'
import readingtwo from './readingtwo.vue'
import readingthree from './readingthree.vue'
import sun from './sun.vue'
import suntwo from './suntwo.vue'
import sunthree from './sunthree.vue'
import zsybookactive from './zsybookactive.vue'
import zsybookrecharge from './zsybookrecharge.vue'
import wdbookactive from './wdbookactive.vue'
import wdbookrecharge from './wdbookrecharge.vue'
import wandubookactive from './wandubookactive.vue'
import wandubookrecharge from './wandubookrecharge.vue'
import qiyueactive from './qiyueactive.vue'
import qiyueactivetwo from './qiyueactivetwo.vue'
import kswbookactive from './kswbookactive.vue'
import zdbookactive from './zdbookactive.vue'
import zdbookrecharge from './zdbookrecharge.vue'
import cdactivey from './cdactivey.vue'
import cdactiveyvip from './cdactiveyvip.vue'
import cdactiveyzhizeng from './cdactiveyzhizeng.vue'
import zwbookacive from './zwbookacive.vue'
import zwbookaciveincrease from './zwbookaciveincrease.vue'
import zwbookacivevip from './zwbookacivevip.vue'
import mogu from './mogu.vue'
import yexiangone from './yexiangone.vue'
import yexiangtwo from './yexiangtwo.vue'
import yexiangthree from './yexiangthree.vue'
import duoge from './duoge.vue'
import duogetwo from './duogetwo.vue'
import wandubookvip from './wandubookvip.vue'
import { strategyPlatformthree } from '@/api/sourceMaterial.js'
export default {
  components: {
    reading,
    readingtwo,
    readingthree,
    sun,
    suntwo,
    sunthree,
    zsybookactive,
    zsybookrecharge,
    wdbookactive,
    wdbookrecharge,
    wandubookactive,
    wandubookrecharge,
    qiyueactive,
    qiyueactivetwo,
    kswbookactive,
    zdbookactive,
    zdbookrecharge,
    cdactivey,
    cdactiveyvip,
    cdactiveyzhizeng,
    zwbookacive,
    zwbookaciveincrease,
    zwbookacivevip,
    mogu,
    yexiangone,
    yexiangtwo,
    yexiangthree,
    duoge,
    duogetwo,
    wandubookvip
  },
  props: {
    activeName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      platformid: null,
      platforms: [],
      activeTopTemp: 'first',
      arr: [],
      readarr: [
        {
          text: '模板充值活动',
          indexrw: 'first'
        },
        {
          text: '模板直赠活动',
          indexrw: 'two'
        },
        {
          text: '模板消耗活动',
          indexrw: 'second'
        }
      ],
      sunarr: [
        {
          text: '书币充值',
          indexrw: 'first'
        },
        {
          text: 'vip充值',
          indexrw: 'second'
        },
        {
          text: '直赠',
          indexrw: 'secondwe'
        }
      ],
      chasingbookscloudarr: [
        {
          text: '追书云创建赠币',
          indexrw: 'first'
        },
        {
          text: '追书云创建充值',
          indexrw: 'second'
        }
      ],
      wdarr: [
        {
          text: '文鼎直赠活动',
          indexrw: 'first'
        },
        {
          text: '文鼎充值活动',
          indexrw: 'second'
        }
      ],
      wandu: [
        {
          text: '万读直赠活动',
          indexrw: 'first'
        },
        {
          text: '万读充值活动',
          indexrw: 'second'
        },
        {
          text: '万读vip活动',
          indexrw: 'secondwe'
        }
      ],
      qiyuearr: [
        {
          text: '七悦充值活动模板',
          indexrw: 'first'
        },
        {
          text: '七悦直赠活动模板',
          indexrw: 'second'
        }
      ],
      kswarr: [
        {
          text: '看书网活动模板',
          indexrw: 'first'
        }
      ],
      zdarr: [
        {
          text: '掌读直赠活动模板',
          indexrw: 'first'
        },
        {
          text: '掌读充值活动模板',
          indexrw: 'second'
        }
      ],
      cdarr: [
        {
          text: '常读充值活动模板',
          indexrw: 'first'
        },
        {
          text: '常读vip活动模板',
          indexrw: 'second'
        },
        {
          text: '常读直赠模板',
          indexrw: 'secondwe'
        }
      ],
      zwarr: [
        {
          text: '中文在线促销活动模板',
          indexrw: 'first'
        },
        {
          text: '中文在线直赠活动模板',
          indexrw: 'second'
        },
        {
          text: '中文在线vip活动模板',
          indexrw: 'secondwe'
        }
      ],
      moguarr: [
        {
          text: '蘑菇',
          indexrw: 'first'
        }
      ],
      yexiangarr: [
        {
          text: '野象充值活动模板',
          indexrw: 'first'
        },
        {
          text: '野象vip活动模板',
          indexrw: 'second'
        },
        {
          text: '野象直赠模板',
          indexrw: 'secondwe'
        }
      ],
      duogearr: [
        {
          text: '朵格充值活动模板',
          indexrw: 'first'
        },
        {
          text: '朵格vip活动模板',
          indexrw: 'second'
        }
      ]
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 获取策略列表
    async strategylist() {
      const data = await strategyPlatformthree()
      this.platforms = data.data.list
      console.log('data', data)
    },
    send(val, arr) {
      this.strategylist()
      // console.log('val222', val, arr)
      // this.platformid = val
      // this.arr = arr
    },
    readingclose() {
      this.$emit('readingclose')
    },
    pirewa(val) {
      console.log('val', val)
      this.activeTopTemp = 'first'
      // eslint-disable-next-line eqeqeq
      if (val == 1) {
        this.arr = this.sunarr
      }
      // eslint-disable-next-line eqeqeq
      if (val == 2) {
        this.arr = this.readarr
      }
      // eslint-disable-next-line eqeqeq
      if (val == 3) {
        this.arr = this.wdarr
      }
      // eslint-disable-next-line eqeqeq
      if (val == 4) {
        this.arr = this.wandu
      }
      // eslint-disable-next-line eqeqeq
      if (val == 6) {
        this.arr = this.qiyuearr
      }
      // eslint-disable-next-line eqeqeq
      if (val == 9) {
        this.arr = this.chasingbookscloudarr
      }
      // eslint-disable-next-line eqeqeq
      if (val == 10) {
        this.arr = this.kswarr
      }
      // eslint-disable-next-line eqeqeq
      if (val == 11) {
        this.arr = this.zdarr
      }
      // eslint-disable-next-line eqeqeq
      if (val == 12) {
        this.arr = this.zwarr
      }
      // eslint-disable-next-line eqeqeq
      if (val == 13) {
        this.arr = this.cdarr
      }
      // eslint-disable-next-line eqeqeq
      if (val == 31) {
        this.arr = this.moguarr
      }
      // eslint-disable-next-line eqeqeq
      if (val == 34) {
        this.arr = this.yexiangarr
      }
      // eslint-disable-next-line eqeqeq
      if (val == 23) {
        this.arr = this.duogearr
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.choose_palte {
  display: flex;
  align-items: center;
}
</style>
